<template>
  <div class="chart-rents-by-years">
    <div class="thumbnail" style="margin-bottom: 0">
      <loading v-if="!chartOptions"/>
      <highcharts v-else :options="chartOptions" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'ChartRentsByYears',
    components: {},
    data () {
      return {
        chartOptions: false
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {
      this.getRentsByYears()
    },
    methods: {
      getRentsByYears () {
        this.loadRentsByYears({ companyId: this.user.company.id })
        .then((response) => {
          this.chartOptions = {
            chart: {
              height: 300,
              type: 'line'
            },
            title: {
              text: 'Locações que foram iniciadas no mês'
            },
            subtitle: {
              text: 'Comparativo: Ano atual X Ano anterior'
            },
            xAxis: {
              categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            },
            yAxis: {
              title: {
                text: 'Quantidade de locações'
              }
            },
            plotOptions: {
              line: {
                dataLabels: {
                  enabled: true
                },
                enableMouseTracking: false
              }
            },
            series: response.data,
            credits: {
              style: {
                color: '#fff'
              }
            }
          }
        }, (error) => {
          console.log(error)
        })
      },
      ...mapActions(['loadRentsByYears'])
    }
  }
</script>


// WEBPACK FOOTER //
// ChartRentsByYears.vue?441f1d99